/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Everyone_PostsInputs */

const cs_sreality_everyone_posts = /** @type {(inputs: Sreality_Everyone_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzeráty všech makléřů v kanceláři jdou přes tyto klíče RK. Makléři nedostávají vlastní XML-RPC heslo.`)
};

const en_sreality_everyone_posts = /** @type {(inputs: Sreality_Everyone_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings from every broker in this office export through these RK keys. Brokers do not get their own XML-RPC password.`)
};

/**
* | output |
* | --- |
* | "Listings from every broker in this office export through these RK keys. Brokers do not get their own XML-RPC password." |
*
* @param {Sreality_Everyone_PostsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_everyone_posts = /** @type {((inputs?: Sreality_Everyone_PostsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Everyone_PostsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_everyone_posts(inputs)
	return cs_sreality_everyone_posts(inputs)
});